/*
 * Handles all modal views.  Is passed the view to show in the modal
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/modal/modalView",
], function (Marionette, Backbone, _, Messenger, ModalView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.modalStack = [];
      this.name = "modal";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (SubModule, options, object, modalOptions) {
      if (!modalOptions) {
        modalOptions = {};
      } else if (modalOptions.trackInteraction) {
        Messenger.vent.trigger("track:interaction", modalOptions.trackInteraction);
      }
      //create model for the layout (insert modal title into layout view)
      const layoutModel = new Backbone.Model({
        title: "",
        backdrop: modalOptions.closeOnBackgroundClick ? true : "static",
        closeButton: false,
        maximizeButton: false,
        maximized: false,
        ...modalOptions,
      });
      if (this.activeModal) {
        this.modalStack.push(this.activeModal);
        this.activeModal = null;
      }
      this._showModal(SubModule, options, object, layoutModel);
    },
    _showModal: function (SubModule, options, object, layoutModel) {
      //set background close (backdrop) property on region
      this.region.backdrop = layoutModel.get("backdrop");

      //save any textboxes, if possible, and if not, then just cancel them
      if (!Messenger.reqres.request("save:textbox")) {
        Messenger.vent.trigger("cancel:textbox");
      }

      //create layout with one region to insert sub-module's view into
      this.layout = new ModalView.modalLayout({
        region: this.region,
        model: layoutModel,
        modalWidth: layoutModel.get("modalWidth"),
        modalHeight: layoutModel.get("modalHeight"),
      });
      const subModuleOptions = { region: this.layout.modal, ...options };
      this.subModule = this.addSubModule(new SubModule(subModuleOptions));
      this.layout.on("show", () => this._showSubViews(object));
      this.activeModal = { SubModule, options, object, layoutModel };
      this.showRegion(this.layout);
    },
    closeModal: function (callback) {
      this.layout.model.set("maximized", false);
      this.activeModal = null;
      if (this.modalStack.length > 0) {
        const modal = this.modalStack.pop();
        this._showModal(modal.SubModule, modal.options, modal.object, modal.layoutModel);
      } else {
        this.region.$el.modal("hide");
      }
      if (callback) {
        callback.call(this);
      }
    },
    destroyModal: function (callback) {
      if (this.region.backdrop && this.region.backdrop === true) {
        this.layout.model.set("maximized", false);
        this.activeModal = null;
        this.modalStack = [];
        this.region.$el.modal("hide");
        if (callback) {
          callback.call(this);
        }
      }
    },
    _showSubViews: function (object) {
      this.subModule.show(object);
    },
    _setUpVents: function () {
      Messenger.vent.on("show:modal", this.show, this);
      Messenger.vent.on("close:modal", this.closeModal, this);
      Messenger.vent.on("destroy:modal", this.destroyModal, this);
    },
  });
});
